/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Number)],
  props: {
    greyed: {type: Boolean, default: false}
  }
}
